import { ILocale } from '@ng-omar/translation';

export const locale: ILocale = {
    code: 'ar',
    strings: {
        'translate_all_rights_reserved_to_syscodeia_for_it_solutions_year':
            'جميع الحقوق محفوظة لدى مؤسسة سيسكوديا لحلول تقنية المعلومات {{year}}©.',
        'translate_feature_not_available': 'الميزة غير متاحة',
        'translate_feature_not_available_contact_us':
            'هذه الميزة غير متوفرة في رخصتك الحالية. لتفعيلها، يرجى التواصل معنا على info@syscodeia.ae',
        'translate_pending_initial_review': 'بانتظار الفحص الأولي',
        'translate_pending_lead_coordinator_decision':
            'بانتظار قرار المنسق الرئيسي',
        'translate_pending_committee_evaluation': 'بانتظار تقييم لجنة الابتكار',
        'translate_pending_organizational_unit_evaluation':
            'بانتظار تقييم الوحدة التنظيمية',
        'translate_pending_execution': 'بانتظار التنفيذ',
        'translate_pending_planned_execution': 'بانتظار التنفيذ المخطط',
        'translate_pending_appealed': 'بانتظار التظلمات',
    },
};
